import { NewsletterVariant } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ContentNewsletterWidget } from "~/components/content/content-newsletter-widget";
import type { newsletterWidgetLiveArticleArticle$key } from "~/queries/__generated__/newsletterWidgetLiveArticleArticle.graphql";

type Props = {
  className?: string;
  reference: newsletterWidgetLiveArticleArticle$key;
};

export const LiveArticleNewsletterWidget: FunctionComponent<Props> = ({ className, reference }) => {
  const article = useFragment(
    graphql`
      fragment newsletterWidgetLiveArticleArticle on Article {
        ...contentNewsletterWidgetContent
      }
    `,
    reference,
  );

  return (
    <div className={className}>
      <ContentNewsletterWidget
        reference={article}
        signUpButtonDisplayComponent={null}
        titleComponent={null}
        variant={NewsletterVariant.LiveArticle}
      />
    </div>
  );
};

LiveArticleNewsletterWidget.displayName = "LiveArticleNewsletterWidget";
